module.exports = __webpack_public_path__ + "media/images/spree/frontend/content/orders/girl_heart-381f4253b1df7be16cffdbd990131d77.jpg";